// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn/v1/portal_service.proto (package spwn.spwn.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { FetchPawBalance, PawChargeHistory, PawPaymentMethod, PawPaymentStatus, PawUsageHistory, SecureTran2Response, SpwnApiResponse } from "./portal_common_pb";
/**
 * PAWの残高を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawBalanceRequest
 */
export class SpwnServiceFetchPawBalanceRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawBalanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawBalanceRequest, a, b);
    }
}
SpwnServiceFetchPawBalanceRequest.runtime = proto3;
SpwnServiceFetchPawBalanceRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawBalanceRequest";
SpwnServiceFetchPawBalanceRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawBalanceResponse
 */
export class SpwnServiceFetchPawBalanceResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawBalanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawBalanceResponse, a, b);
    }
}
SpwnServiceFetchPawBalanceResponse.runtime = proto3;
SpwnServiceFetchPawBalanceResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawBalanceResponse";
SpwnServiceFetchPawBalanceResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: FetchPawBalance },
]);
/**
 * PAWのチャージ履歴を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryRequest
 */
export class SpwnServiceFetchPawChargeHistoryRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawChargeHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawChargeHistoryRequest, a, b);
    }
}
SpwnServiceFetchPawChargeHistoryRequest.runtime = proto3;
SpwnServiceFetchPawChargeHistoryRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryRequest";
SpwnServiceFetchPawChargeHistoryRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryResponse
 */
export class SpwnServiceFetchPawChargeHistoryResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.spwn.v1.PawChargeHistory data = 2;
         */
        this.data = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawChargeHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawChargeHistoryResponse, a, b);
    }
}
SpwnServiceFetchPawChargeHistoryResponse.runtime = proto3;
SpwnServiceFetchPawChargeHistoryResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawChargeHistoryResponse";
SpwnServiceFetchPawChargeHistoryResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PawChargeHistory, repeated: true },
]);
/**
 * PAWの使用履歴を取得する
 *
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryRequest
 */
export class SpwnServiceFetchPawUsageHistoryRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawUsageHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawUsageHistoryRequest, a, b);
    }
}
SpwnServiceFetchPawUsageHistoryRequest.runtime = proto3;
SpwnServiceFetchPawUsageHistoryRequest.typeName = "spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryRequest";
SpwnServiceFetchPawUsageHistoryRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryResponse
 */
export class SpwnServiceFetchPawUsageHistoryResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from field: repeated spwn.spwn.v1.PawUsageHistory data = 2;
         */
        this.data = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceFetchPawUsageHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceFetchPawUsageHistoryResponse, a, b);
    }
}
SpwnServiceFetchPawUsageHistoryResponse.runtime = proto3;
SpwnServiceFetchPawUsageHistoryResponse.typeName = "spwn.spwn.v1.SpwnServiceFetchPawUsageHistoryResponse";
SpwnServiceFetchPawUsageHistoryResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PawUsageHistory, repeated: true },
]);
/**
 * 新規クレカでのPAW購入
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCardRequest
 */
export class SpwnServicePurchasePawWithCardRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * @generated from field: string token = 2;
         */
        this.token = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCardRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithCardRequest, a, b);
    }
}
SpwnServicePurchasePawWithCardRequest.runtime = proto3;
SpwnServicePurchasePawWithCardRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCardRequest";
SpwnServicePurchasePawWithCardRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCardResponse
 */
export class SpwnServicePurchasePawWithCardResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCardResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithCardResponse, a, b);
    }
}
SpwnServicePurchasePawWithCardResponse.runtime = proto3;
SpwnServicePurchasePawWithCardResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCardResponse";
SpwnServicePurchasePawWithCardResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PurchasePawWithCardResult },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSRequest
 */
export class SpwnServicePurchasePawWithCard3DSRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * @generated from field: string token = 2;
         */
        this.token = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCard3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithCard3DSRequest, a, b);
    }
}
SpwnServicePurchasePawWithCard3DSRequest.runtime = proto3;
SpwnServicePurchasePawWithCard3DSRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSRequest";
SpwnServicePurchasePawWithCard3DSRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse
 */
export class SpwnServicePurchasePawWithCard3DSResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from oneof spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse.data
         */
        this.data = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithCard3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithCard3DSResponse, a, b);
    }
}
SpwnServicePurchasePawWithCard3DSResponse.runtime = proto3;
SpwnServicePurchasePawWithCard3DSResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithCard3DSResponse";
SpwnServicePurchasePawWithCard3DSResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
    { no: 3, name: "purchase_result", kind: "message", T: PurchasePawWithCardResult, oneof: "data" },
]);
/**
 * @generated from message spwn.spwn.v1.PurchasePawWithCardResult
 */
export class PurchasePawWithCardResult extends Message {
    constructor(data) {
        super();
        /**
         * 注文ID
         *
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * トランザクションID
         *
         * @generated from field: string transaction_id = 2;
         */
        this.transactionId = "";
        /**
         * チャージされた金額
         *
         * @generated from field: int32 charged_amount = 3;
         */
        this.chargedAmount = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PurchasePawWithCardResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchasePawWithCardResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchasePawWithCardResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurchasePawWithCardResult, a, b);
    }
}
PurchasePawWithCardResult.runtime = proto3;
PurchasePawWithCardResult.typeName = "spwn.spwn.v1.PurchasePawWithCardResult";
PurchasePawWithCardResult.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "charged_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 既存クレカでのPAW購入
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMemberRequest
 */
export class SpwnServicePurchasePawWithMemberRequest extends Message {
    constructor(data) {
        super();
        /**
         * チャージ金額
         *
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * カード連番 gmoから
         *
         * @generated from field: string card_seq = 2;
         */
        this.cardSeq = "";
        /**
         * カードセキュリティコード
         *
         * @generated from field: string security_code = 3;
         */
        this.securityCode = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithMemberRequest, a, b);
    }
}
SpwnServicePurchasePawWithMemberRequest.runtime = proto3;
SpwnServicePurchasePawWithMemberRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMemberRequest";
SpwnServicePurchasePawWithMemberRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_seq", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "security_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMemberResponse
 */
export class SpwnServicePurchasePawWithMemberResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithMemberResponse, a, b);
    }
}
SpwnServicePurchasePawWithMemberResponse.runtime = proto3;
SpwnServicePurchasePawWithMemberResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMemberResponse";
SpwnServicePurchasePawWithMemberResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: PurchasePawWithMemberResult },
]);
/**
 * @generated from message spwn.spwn.v1.PurchasePawWithMemberResult
 */
export class PurchasePawWithMemberResult extends Message {
    constructor(data) {
        super();
        /**
         * チャージ状態のリスト
         *
         * @generated from field: repeated spwn.spwn.v1.ChargeStatus charges = 1;
         */
        this.charges = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PurchasePawWithMemberResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurchasePawWithMemberResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurchasePawWithMemberResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurchasePawWithMemberResult, a, b);
    }
}
PurchasePawWithMemberResult.runtime = proto3;
PurchasePawWithMemberResult.typeName = "spwn.spwn.v1.PurchasePawWithMemberResult";
PurchasePawWithMemberResult.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charges", kind: "message", T: ChargeStatus, repeated: true },
]);
/**
 * @generated from message spwn.spwn.v1.ChargeStatus
 */
export class ChargeStatus extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string charge_history_id = 1;
         */
        this.chargeHistoryId = "";
        /**
         * チャージ金額
         *
         * @generated from field: int64 value = 2;
         */
        this.value = protoInt64.zero;
        /**
         * 使用可能PAW
         *
         * @generated from field: int64 valid_value = 3;
         */
        this.validValue = protoInt64.zero;
        /**
         * 有効期限
         *
         * @generated from field: int64 expires_at = 4;
         */
        this.expiresAt = protoInt64.zero;
        /**
         * チャージ日時
         *
         * @generated from field: int64 charged_at = 5;
         */
        this.chargedAt = protoInt64.zero;
        /**
         * 支払い方法
         *
         * @generated from field: spwn.spwn.v1.PawPaymentMethod payment_method = 6;
         */
        this.paymentMethod = PawPaymentMethod.UNSPECIFIED;
        /**
         * 支払いステータス
         *
         * @generated from field: spwn.spwn.v1.PawPaymentStatus payment_status = 7;
         */
        this.paymentStatus = PawPaymentStatus.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChargeStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChargeStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChargeStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChargeStatus, a, b);
    }
}
ChargeStatus.runtime = proto3;
ChargeStatus.typeName = "spwn.spwn.v1.ChargeStatus";
ChargeStatus.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charge_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "valid_value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "expires_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "charged_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "payment_method", kind: "enum", T: proto3.getEnumType(PawPaymentMethod) },
    { no: 7, name: "payment_status", kind: "enum", T: proto3.getEnumType(PawPaymentStatus) },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceUsePawValueRequest
 */
export class SpwnServiceUsePawValueRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string item_id = 1;
         */
        this.itemId = "";
        /**
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated string gift_places = 4;
         */
        this.giftPlaces = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceUsePawValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceUsePawValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceUsePawValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceUsePawValueRequest, a, b);
    }
}
SpwnServiceUsePawValueRequest.runtime = proto3;
SpwnServiceUsePawValueRequest.typeName = "spwn.spwn.v1.SpwnServiceUsePawValueRequest";
SpwnServiceUsePawValueRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "firestore_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "gift_places", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceUsePawValueResponse
 */
export class SpwnServiceUsePawValueResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceUsePawValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceUsePawValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceUsePawValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceUsePawValueResponse, a, b);
    }
}
SpwnServiceUsePawValueResponse.runtime = proto3;
SpwnServiceUsePawValueResponse.typeName = "spwn.spwn.v1.SpwnServiceUsePawValueResponse";
SpwnServiceUsePawValueResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
]);
/**
 * 3DセキュアのSecureTran2のリクエスト
 *
 * @generated from message spwn.spwn.v1.SpwnServiceSecureTran2Request
 */
export class SpwnServiceSecureTran2Request extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string access_id = 1;
         */
        this.accessId = "";
        /**
         * @generated from field: string access_pass = 2;
         */
        this.accessPass = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceSecureTran2Request().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceSecureTran2Request().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceSecureTran2Request().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceSecureTran2Request, a, b);
    }
}
SpwnServiceSecureTran2Request.runtime = proto3;
SpwnServiceSecureTran2Request.typeName = "spwn.spwn.v1.SpwnServiceSecureTran2Request";
SpwnServiceSecureTran2Request.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "access_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_pass", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 3DセキュアのSecureTran2のレスポンス
 *
 * @generated from message spwn.spwn.v1.SpwnServiceSecureTran2Response
 */
export class SpwnServiceSecureTran2Response extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceSecureTran2Response().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceSecureTran2Response().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceSecureTran2Response().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceSecureTran2Response, a, b);
    }
}
SpwnServiceSecureTran2Response.runtime = proto3;
SpwnServiceSecureTran2Response.typeName = "spwn.spwn.v1.SpwnServiceSecureTran2Response";
SpwnServiceSecureTran2Response.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "data", kind: "message", T: SecureTran2Response },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSRequest
 */
export class SpwnServiceCompletePurchasePAWWith3DSRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string access_id = 1;
         */
        this.accessId = "";
        /**
         * @generated from field: string access_pass = 2;
         */
        this.accessPass = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceCompletePurchasePAWWith3DSRequest, a, b);
    }
}
SpwnServiceCompletePurchasePAWWith3DSRequest.runtime = proto3;
SpwnServiceCompletePurchasePAWWith3DSRequest.typeName = "spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSRequest";
SpwnServiceCompletePurchasePAWWith3DSRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "access_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_pass", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSResponse
 */
export class SpwnServiceCompletePurchasePAWWith3DSResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServiceCompletePurchasePAWWith3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServiceCompletePurchasePAWWith3DSResponse, a, b);
    }
}
SpwnServiceCompletePurchasePAWWith3DSResponse.runtime = proto3;
SpwnServiceCompletePurchasePAWWith3DSResponse.typeName = "spwn.spwn.v1.SpwnServiceCompletePurchasePAWWith3DSResponse";
SpwnServiceCompletePurchasePAWWith3DSResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
]);
/**
 * 登録済みクレカでのPAW購入（3Dセキュア2.0対応版）
 *
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSRequest
 */
export class SpwnServicePurchasePawWithMember3DSRequest extends Message {
    constructor(data) {
        super();
        /**
         * チャージ金額
         *
         * @generated from field: int32 charge_amount = 1;
         */
        this.chargeAmount = 0;
        /**
         * カード連番 gmoから
         *
         * @generated from field: string card_seq = 2;
         */
        this.cardSeq = "";
        /**
         * カードセキュリティコード
         *
         * @generated from field: string security_code = 3;
         */
        this.securityCode = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMember3DSRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithMember3DSRequest, a, b);
    }
}
SpwnServicePurchasePawWithMember3DSRequest.runtime = proto3;
SpwnServicePurchasePawWithMember3DSRequest.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSRequest";
SpwnServicePurchasePawWithMember3DSRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "charge_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "card_seq", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "security_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse
 */
export class SpwnServicePurchasePawWithMember3DSResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.spwn.v1.SpwnApiResponse status = 1;
         */
        this.status = SpwnApiResponse.UNSPECIFIED;
        /**
         * @generated from oneof spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse.data
         */
        this.data = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpwnServicePurchasePawWithMember3DSResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpwnServicePurchasePawWithMember3DSResponse, a, b);
    }
}
SpwnServicePurchasePawWithMember3DSResponse.runtime = proto3;
SpwnServicePurchasePawWithMember3DSResponse.typeName = "spwn.spwn.v1.SpwnServicePurchasePawWithMember3DSResponse";
SpwnServicePurchasePawWithMember3DSResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(SpwnApiResponse) },
    { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
    { no: 3, name: "purchase_result", kind: "message", T: PurchasePawWithCardResult, oneof: "data" },
]);
//# sourceMappingURL=portal_service_pb.js.map